import { render, staticRenderFns } from "./CourseVideoPlaceholderIntroEnd.vue?vue&type=template&id=7cdc24d1&scoped=true"
import script from "./CourseVideoPlaceholderIntroEnd.vue?vue&type=script&lang=js"
export * from "./CourseVideoPlaceholderIntroEnd.vue?vue&type=script&lang=js"
import style0 from "./CourseVideoPlaceholderIntroEnd.vue?vue&type=style&index=0&id=7cdc24d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdc24d1",
  null
  
)

export default component.exports